import request from '@/utils/request'

// 分页查询用户组信息
export function getPageList(params) {
  return request({
    url: '/hrApi/userGroup',
    method: 'get',
    params: params
  })
}

// 获取用户组列表
export function getList(params) {
  return request({
    url: '/hrApi/userGroup/list',
    method: 'get',
    params: params
  })
}

// 新增或编辑用户组
export function saveOrUpdateData(data) {
  return request({
    url: '/hrApi/userGroup',
    method: 'post',
    data: data
  })
}

// 删除用户组
export function deleteData(id) {
  return request({
    url: '/hrApi/userGroup/' + id,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/userGroup.js